import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router';
import auth from 'services/auth';

export default function useLoginPage() {
  const { setUser, setLoading } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  async function onSubmit(e) {
    e.preventDefault();
    const { login, senha } = e.target;

    try {
      setLoading(true);
      const { error, user } = await auth.login(login.value, senha.value);
      setLoading(false);
      if (!error) {
        setUser({ isAuthenticated: true, ...user });
        navigate('/');
      } else {
        throw new Error(error.message);
      }
    } catch (err) {
      setError(err.message);
      setLoading(false);
      setTimeout(() => setError(null), 2000);
    }
  }

  return { error, onSubmit };
}
